/* No requests or variant mutations: render HTML swatches, then preview card images. */
if (!customElements.get('ltc-card-swatches')) {
  customElements.define('ltc-card-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('ltc-enhanced');
      // A selected color beyond the first four must remain visible.
      if (this.querySelector('[data-ltc-extra][aria-current="true"]')) this.expand(false);
      this.addEventListener('click', (event) => {
        const more = event.target.closest('[data-ltc-more]');
        if (more && this.contains(more)) {
          event.preventDefault();
          this.expand(true);
          return;
        }
        const swatch = event.target.closest('[data-ltc-swatch]');
        if (!swatch || !this.contains(swatch)) return;
        // Preserve open-in-new-tab/window and normal anchor behavior without an image.
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const card = this.closest('.card-wrapper');
        const img = card?.querySelector('[data-ltc-card-image]');
        if (!img || !swatch.dataset.imageSrc) return;
        event.preventDefault();
        this.querySelectorAll('[data-ltc-swatch]').forEach((item) => {
          item.setAttribute('aria-current', String(item === swatch));
        });
        card.classList.add('ltc-card-color-picked');
        img.srcset = swatch.dataset.imageSrcset || '';
        img.src = swatch.dataset.imageSrc;
        img.alt = swatch.dataset.imageAlt || '';
        img.width = Number(swatch.dataset.imageWidth);
        img.height = Number(swatch.dataset.imageHeight);
        card.querySelectorAll('[data-ltc-card-link]').forEach((link) => {
          link.href = swatch.href;
        });
      });
    }

    expand(moveFocus) {
      this.classList.add('ltc-expanded');
      const button = this.querySelector('[data-ltc-more]');
      if (button) button.setAttribute('aria-expanded', 'true');
      if (moveFocus) this.querySelector('[data-ltc-extra]')?.focus();
    }
  });
}
